import { ChatMessageHeaderView } from '@sp/ui/chat';
import { FC, ReactNode } from 'react';
import { useChatMessage } from './chat-message-context';

export const ChatMessageHeader: FC<{
  showDate?: boolean;
  afterUserNameContent?: ReactNode;
  showEditButton?: boolean;
  onEditClick?: () => void;
}> = ({ showDate = true, showEditButton = false, afterUserNameContent = null, onEditClick }) => {
  const { message } = useChatMessage();
  return (
    <ChatMessageHeaderView
      author={message.user?.name ?? 'Unknown'}
      date={message.created_at}
      showDate={showDate}
      afterUserNameContent={afterUserNameContent}
      showEditButton={showEditButton}
      onEditClick={onEditClick}
    />
  );
};
